import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Flyer = lazy(() => import('../pages/flyer/page'));
const ProfessionalTemplate = lazy(() => import('../pages/templates/professional/page'));
const ModernTemplate = lazy(() => import('../pages/templates/modern/page'));
const LegalTemplate = lazy(() => import('../pages/templates/legal/page'));
const FreelancerTemplate = lazy(() => import('../pages/templates/freelancer/page'));
const AgencyTemplate = lazy(() => import('../pages/templates/agency/page'));
const SpecialistTemplate = lazy(() => import('../pages/templates/specialist/page'));
const ExecutiveTemplate = lazy(() => import('../pages/templates/executive/page'));
const BoutiqueTemplate = lazy(() => import('../pages/templates/boutique/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/flyer',
    element: <Flyer />,
  },
  {
    path: '/templates/professional',
    element: <ProfessionalTemplate />,
  },
  {
    path: '/templates/modern',
    element: <ModernTemplate />,
  },
  {
    path: '/templates/legal',
    element: <LegalTemplate />,
  },
  {
    path: '/templates/freelancer',
    element: <FreelancerTemplate />,
  },
  {
    path: '/templates/agency',
    element: <AgencyTemplate />,
  },
  {
    path: '/templates/specialist',
    element: <SpecialistTemplate />,
  },
  {
    path: '/templates/executive',
    element: <ExecutiveTemplate />,
  },
  {
    path: '/templates/boutique',
    element: <BoutiqueTemplate />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
